const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, itemsPerPage }) => {
    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <div className="flex justify-between items-center py-6 border-t border-zinc-700 last:md:col-span-2 ">
            <div className="text-sm text-zinc-400">
                Showing {startItem} to {endItem} of {totalItems} results
            </div>
            
            <div className="flex items-center space-x-2">
                <button
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                    className={`px-3 py-1.5 rounded-lg border ${
                        currentPage === 1
                            ? 'border-zinc-700 text-zinc-600 cursor-not-allowed'
                            : 'border-zinc-700 text-white hover:bg-charleston-green'
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                    </svg>
                </button>
                
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`px-3 py-1.5 rounded-lg border ${
                        currentPage === 1
                            ? 'border-zinc-700 text-zinc-600 cursor-not-allowed'
                            : 'border-zinc-700 text-white hover:bg-charleston-green'
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                {startPage > 1 && (
                    <>
                        <button
                            onClick={() => onPageChange(1)}
                            className="px-3 py-1.5 rounded-lg border border-zinc-700 text-white hover:bg-charleston-green"
                        >
                            1
                        </button>
                        {startPage > 2 && <span className="text-zinc-600">...</span>}
                    </>
                )}

                {pages.map(page => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`px-3 py-1.5 rounded-lg border ${
                            currentPage === page
                                ? 'bg-sefid-white text-white border-sefid-white font-medium'
                                : 'border-zinc-700 text-white hover:bg-charleston-green'
                        }`}
                    >
                        {page}
                    </button>
                ))}

                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && <span className="text-zinc-600">...</span>}
                        <button
                            onClick={() => onPageChange(totalPages)}
                            className="px-3 py-1.5 rounded-lg border border-zinc-700 text-white hover:bg-charleston-green"
                        >
                            {totalPages}
                        </button>
                    </>
                )}

                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1.5 rounded-lg border ${
                        currentPage === totalPages
                            ? 'border-zinc-700 text-zinc-600 cursor-not-allowed'
                            : 'border-zinc-700 text-white hover:bg-charleston-green'
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </button>
                
                <button
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1.5 rounded-lg border ${
                        currentPage === totalPages
                            ? 'border-zinc-700 text-zinc-600 cursor-not-allowed'
                            : 'border-zinc-700 text-white hover:bg-charleston-green'
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default Pagination;